import React from 'react';
import { Provider, defaultTheme } from '@adobe/react-spectrum';
import { ContextDevTool } from 'react-context-devtool';
import { ThemeContext } from './ThemeContext';
import { MediaBreakpointsProvider } from '../MediaBreakpoint';
import { breakpoints } from '../../design-system/breakpoints';

/**
 * @deprecated Please use {@link SendPaymentsTheme} instead.
 *
 * There are too many props here for theming. The blocker for removing this is the
 * website project (sendpayments.com). Please check that any changes
 * are supported by website if another refactor is done.
 *
 * @param {{
 *  name: string;
 *  localTheme: { globals: string };
 *  children: any;
 *  theme?: import('@react-types/provider').Theme;
 *  colorScheme?: 'light' | 'dark';
 *  spectrumOverrides?: { light: Record<string, any>, dark: Record<string, any> };
 * }} props
 */
const ThemeProvider = ({ name, children, colorScheme = 'light', theme, localTheme, spectrumOverrides }) => (
  <MediaBreakpointsProvider breakpoints={breakpoints}>
    <ThemeContext.Provider value={{ colorScheme, theme, localTheme, spectrumOverrides }}>
      <Provider theme={theme} colorScheme={colorScheme} UNSAFE_style={{ backgroundColor: 'transparent', height: 'inherit' }}>
        <ContextDevTool context={ThemeContext} id={`Theme_${name}`} displayName={`Theme_${name}`} />
        {children}
      </Provider>
    </ThemeContext.Provider>
  </MediaBreakpointsProvider>
);

ThemeProvider.defaultProps = {
  name: 'ThemeProvider',
  theme: defaultTheme,
  localTheme: undefined,
  spectrumOverrides: undefined,
  overrideBreakpoints: undefined,
};

export default ThemeProvider;
